import type { ReactNode } from "react";

/**
 * What fills the table frame when there is no table: nothing recorded yet, a
 * filter that matched nothing, or a feature that is switched off. Each one says
 * what would put rows here, because "No data" teaches nobody anything.
 */
export function ChangelogNotice({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      <p className="m-0 text-sm font-medium">{title}</p>
      <p className="m-0 max-w-[52ch] text-xs text-muted-foreground">{description}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
